<template>
  <div class="relationship-detail">
    <!--基本信息-->
    <a-card title="基本信息">
      <a-row>
        <a-col :span="8">企业ID: {{ baseInfo.code }}</a-col>
        <a-col :span="8">企业名称: {{ baseInfo.name }}</a-col>
        <a-col :span="8">关联类型: {{ typeList(type) }}</a-col>

        <a-skeleton active :loading="skeletonLoding">
          <contact-info
            ref="contactInfo"
            v-if="detail"
            :customerDetail="detail"
            :groupCode="groupCode"
            :skeletonLoding="skeletonLoding"
            @hanleDetail="_customerDetail"
          ></contact-info>
        </a-skeleton>
      </a-row>
    </a-card>
    <!--关联信息-->
    <a-card style="margin-top: 20px" title="关联信息">
      <a-form-model ref="ruleForm" inline :model="form" :rules="rules">
        <a-row :gutter="{ xs: 8, sm: 16, md: 24 }">
          <a-col :lg="8" :md="12" :sm="24">
            <a-form-model-item label="母公司ID" prop="parentCode">
              <a-auto-complete
                placeholder="请输入母公司ID"
                @select="handleSelect"
                @search="handleSearch"
                v-model="form.parentCode"
                :allow-clear="true"
              >
                <template slot="dataSource">
                  <a-select-option
                    v-for="item in compList"
                    :key="item.code"
                    :value="JSON.stringify(item)"
                  >
                    {{ item.code }}
                  </a-select-option>
                </template>
              </a-auto-complete>
            </a-form-model-item>
          </a-col>
          <a-col :lg="8" :md="12" :sm="24">
            <a-form-model-item label="母公司名称" prop="parentName">
              <a-auto-complete
                placeholder="请输入母公司名称"
                @select="handleSelect"
                @search="handleSearch"
                v-model="form.parentName"
                :allow-clear="true"
              >
                <template slot="dataSource">
                  <a-select-option
                    v-for="item in compList"
                    :key="item.code"
                    :value="JSON.stringify(item)"
                  >
                    {{ item.name }}
                  </a-select-option>
                </template>
              </a-auto-complete>
            </a-form-model-item>
          </a-col>
          <a-col :lg="8" :md="12" :sm="24">
            <a-form-model-item label="母公司是否上市" prop="listedStatus">
              <a-select
                v-model="form.listedStatus"
                placeholder="请选择"
                style="width: 275px"
                allowClear
                @change="handleIsChange"
              >
                <a-select-option
                  v-for="item in YSList"
                  :key="item.value"
                  :value="item.value"
                >
                  {{ item.name }}
                </a-select-option>
              </a-select>
            </a-form-model-item>
          </a-col>
          <a-col :lg="8" :md="12" :sm="24" prop="groupName">
            <a-form-model-item label="所属集团名称">
              <a-input
                v-model="form.groupName"
                style="width: 100%"
                allowClear
              ></a-input>
            </a-form-model-item>
          </a-col>
          <a-col :lg="8" :md="12" :sm="24">
            <a-form-model-item label="关联理由" prop="relationReason">
              <a-select
                v-model="form.relationReason"
                @change="handleReasonChange"
                placeholder="请选择"
                style="width: 275px"
                allowClear
              >
                <a-select-option
                  v-for="item in statusList"
                  :key="item.value"
                  :value="item.value"
                >
                  {{ item.name }}
                </a-select-option>
              </a-select>
            </a-form-model-item>
          </a-col>
        </a-row>

        <a-skeleton :loading="loading">
          <h3 class="margin-top-40">母公司账期</h3>
          <table-view
            id="mod4"
            :columns="segments"
            :data="segmentData"
            :pagination="pagination"
          ></table-view>
        </a-skeleton>
      </a-form-model>
    </a-card>
    <!-- 申请说明 -->
    <a-card style="margin-top: 20px">
      <div class="apply-reason-memo" style="margin: 20px 0">
        <div class="ant-descriptions-title">申请原因及备注</div>
        <quill-editor :token="token" ref="quillEditor"></quill-editor>
        <affix ref="affix" style="margin-top: 20px" :maxSize="30"></affix>
      </div>
    </a-card>
    <!-- 增加审批人 -->
    <a-card title="增加审批人" style="margin: 10px 0px">
      <a-select
        style="width: 300px"
        v-model="approvePerson"
        showSearch
        allowClear
        option-filter-prop="children"
        required
      >
        <a-select-option v-for="item in managerList" :key="item.username">
          {{ item.name }} - {{ item.username }}
        </a-select-option>
      </a-select>
    </a-card>

    <!-- 提交 -->
    <footer-tool-bar>
      <a-button @click="goBack" style="margin: 0px 20px">取消</a-button>
      <a-button type="primary" @click="handleSubmit" :loading="loading">
        提交
      </a-button>
    </footer-tool-bar>
  </div>
</template>

<script>
import {
  getParentList,
  getApprovePersons,
  queryBase,
  addGroup,
  searchTerm,
} from './api'
import QuillEditor from '../../credit-approval/components/QuillEditor.vue'
import FooterToolBar from 'components/FooterToolBar.vue'
import Affix from '../components/Affix.vue'
import { mapGetters } from 'vuex'
import { TableView } from 'lxfintech-fe'
import { segments } from './schema.js'
import ContactInfo from './ContactInfo.vue'
export default {
  data() {
    //这里存放数据
    return {
      loading: false,
      form: {
        parentCode: '',
        parentName: '',
        listedStatus: '',
        groupName: '',
        relationReason: '',
      },
      type: '',
      baseInfo: {},
      rules: {
        parentCode: [
          {
            required: true,
            message: '请输入企业ID',
            trigger: 'blur',
          },
        ],
        parentName: [
          {
            required: true,
            message: '请输入企业名称',
            trigger: 'blur',
          },
        ],
        listedStatus: [
          {
            required: true,
            message: '请选择母公司是否上市',
            trigger: 'change',
          },
        ],
        relationReason: [
          {
            required: true,
            message: '请输入关联理由',
            trigger: 'blur',
          },
        ],
      },
      compList: [],
      statusList: [
        {
          value: 1,
          name: '1.直销统签客户',
        },
        {
          value: 2,
          name: '2.母公司对子公司的绝对控股权',
        },
        {
          value: 3,
          name: '3.分公司',
        },
        {
          value: 4,
          name: '4.集团公司开具的关联证明',
        },
        {
          value: 5,
          name: '5.GAB 客户',
        },
        {
          value: 6,
          name: '6.通过集中采购平台下单',
        },
        {
          value: 7,
          name: '7.重复客户',
        },
      ],
      managerList: [],
      approvePerson: '',
      YSList: [
        {
          value: 1,
          name: '是',
        },
        {
          value: 2,
          name: '否',
        },
      ],
      segments,
      segmentData: [],
      pagination: false,
      skeletonLoding: true,
      detail: {},
      groupCode: '',
      listedStatusStr: '',
    }
  },
  components: {
    QuillEditor,
    Affix,
    FooterToolBar,
    TableView,
    ContactInfo,
  },
  computed: {
    ...mapGetters('user', ['token']),
  },
  //方法集合
  methods: {
    typeList(type) {
      switch (type) {
        case '1':
          return (type = '关联共享')
        case '2':
          return (type = '关联分配')
      }
    },

    //公司账期详情
    _customerDetail() {
      searchTerm(this.companyCode).then(({ data }) => {
        this.detail = data
        this.skeletonLoding = false
      })
    },

    handleReasonChange() {
      this.change()
    },
    handleIsChange(value) {
      this.listedStatusStr = value
      this.change()
    },
    change() {
      this._getApprovePersons(this.form.relationReason, this.listedStatusStr)
    },
    async _getApprovePersons(relationReasonStr, listedStatusStr) {
      try {
        if (relationReasonStr === 7 || listedStatusStr == 1) {
          const status = 1
          const { data } = await getApprovePersons(status)
          this.managerList = data
        } else {
          const status = 2
          const { data } = await getApprovePersons(status)
          this.managerList = data
        }
      } catch (error) {
        this.loading = false
        console.error(error)
      }
    },
    goBack() {
      this.$router.go(-1)
    },
    handleSelect(value) {
      const selectedValue = JSON.parse(value)
      this.form.parentCode = selectedValue.code
      this.form.parentName = selectedValue.name
      this.form.groupName = selectedValue.groupName
      this.compList = []

      this.getTerm(this.form.parentCode)
    },
    async getTerm(code) {
      if (!code.trim()) {
        return
      }
      try {
        const { data } = await searchTerm(code)
        this.segmentData = data
      } catch (error) {
        console.error(error)
      }
    },

    async handleSearch(value) {
      if (!value.trim()) {
        return
      }
      try {
        const { data } = await getParentList(value)
        this.compList = data
      } catch (error) {
        console.error(error)
      }
    },

    async getBaseInfo(companyCode) {
      try {
        const { data } = await queryBase(companyCode)
        this.baseInfo = data
        this.groupCode = data.code
      } catch (error) {
        console.log(error)
      }
    },
    async handleSubmit() {
      if (this.$refs.contactInfo.data.length == 0) {
        return this.$message.error('子公司至少需要一条账期数据！')
      }
      this.loading = true
      const valid = await this.$refs.ruleForm.validate()
      if (valid) {
        try {
          const query = {
            approvePerson: this.approvePerson,
            ...this.form,
            childCode: this.baseInfo.code,
            childName: this.baseInfo.name,
            relationType: this.type,
            applyRemark: this.$refs.quillEditor.getContent(),
            attachmentIds: this.$refs.affix.getAttachmentIds(),
            //子公司账期
            companyTerm: this.$refs.contactInfo.data,
          }
          console.log(query)
          await addGroup(query)
          this.$message.success('成功')
          this.$router.push('/customer-credit/group-relationship-mana')
          setTimeout(() => {
            this.loading = false
          }, 1000)
        } catch (error) {
          this.loading = false
          console.log(error)
        }
      }
      this.loading = false
    },
  },
  //生命周期 - 创建完成（访问当前this实例）
  created() {},
  //生命周期 - 挂载完成（访问DOM元素）
  mounted() {
    this.type = this.$route.query.type
    this.companyCode = this.$route.params.companyCode
    this.getBaseInfo(this.companyCode)
    this._getApprovePersons()
    this.change()
    this._customerDetail()
  },
}
</script>
<style scoped>
/* @import url(); 引入css类 */
</style>
